import React from 'react'
import { PMPFooterContainer } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'

export default function ListPointerCenerAligned({
  prescriptionData,
  noColor,
  hideQr = true,
  debug = false,
  styleOverrides,
}) {
  return (
    <PMPFooterContainer
      noColor={noColor}
      threeColFooter
      debug={debug}
      style={{
        display: 'flex',
        alignItems: 'flex-center',
        flexDirection: 'column',
        fontSize: `${styleOverrides?.fontSizePixels || 11}px`,
        padding: '5px 10px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: '1.2em', textAlign: 'center' }} className="mb-2">
        {prescriptionData?.footer?.disclaimerText}
      </div>
      <div className="mb-2">{prescriptionData?.footer?.subtext}</div>
      {(prescriptionData?.footer?.footerListItems || [])?.map((listItem, idx) => {
        return (
          <div key={idx} style={{ marginBottom: '2px' }}>
            {listItem}
          </div>
        )
      })}
    </PMPFooterContainer>
  )
}
